import { TWidget } from 'widgets/Widget';
/**
 * @description Base Button implementation
 * @param Widget - widget for extending
 * @returns Link widget
 */

function LinkClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory global
     * @class Link
     * @augments Widget
     * @classdesc Button widget, which could be used in different contexts (html-markup, inside widgets etc).
     * <br>Could be also used to trigger parent's widget method
     */
    class Button extends Widget {
        /**
         * @description Returns Widget configuration object
         * @returns Widget configuration object
         */
        prefs() {
            return {
                preventAction: false,
                ...super.prefs()
            };
        }

        /**
         * @description Handles button click
         * @listens dom:click
         * @emits Button#click
         */
        handleClick() {
            if (!this.prefs().preventAction) {
                /**
                 * @description Emits button click event
                 * @event Button#click
                 */
                this.emit('click', this);
            }
        }
    }

    return Button;
}

export type TLink = ReturnType<typeof LinkClassCreator>;

export type TLinkInstance = InstanceType<TLink>;

export default LinkClassCreator;
